const productDisplay = () => {
    const product = document.querySelectorAll('.product')

    if (product) {
        product.forEach((item) => {
            const buyBtn = item.querySelector('.btn')

            if (buyBtn) {
                buyBtn.addEventListener('click', function () {
                    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
                        const orderDialog = document.querySelector('.adv-wrap')

                        if (orderDialog) {
                            const previousItems = document.querySelectorAll('.product-item')

                            if (previousItems) {
                                previousItems.forEach((item) => {
                                    item.remove()
                                })
                            }

                            const image = item.querySelector('.image img')?.src
                            const qty = item.querySelector('.quantity .amount')?.value
                            const title = item.querySelector('.name span')?.textContent
                            const title2 = item.querySelector('.name')?.textContent
                            let price = item
                                .querySelector('.price.price-final strong')
                                ?.textContent?.replace(/\D/g, '')

                            if (qty > 1) {
                                price = Number(price) * qty
                            }

                            console.log(title)

                            const productInfoTemplate = `
                            <div class="product-item__information">
                                <div class="product-item__information--image">
                                    <img src="${image}" alt="product image">
                                </div>
                                <div class="product-item__information--title">
                                    ${title ? title : title2}
                                </div>
                            </div>
                        `
                            const productAmountTemplate = `
                            <div class="product-item__ammount">${qty} Ks</div>
                         `
                            const productPriceTemplate = `
                            <div class="product-item__price">${price} Kč</div>
                        `

                            const template = `
                            <div class = "product-item">
                                ${productInfoTemplate}
                                ${productAmountTemplate}
                                ${productPriceTemplate}
                            </div>
                         `

                            orderDialog.insertAdjacentHTML('afterend', template)
                        }
                    })
                })
            }
        })
    }
}

$(document).ready(function () {
    setTimeout(() => {
        productDisplay()
    }, 1000)

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        productDisplay()
    })
    document.addEventListener('ShoptetPageFiltersRecalledFromHistory', function () {
        productDisplay()
    })
})
